import React from "react"
import { useGeneralSettings } from "hooks/useGeneralSettings"
import { Button } from "components/button"
import { useNavigationItems } from "hooks/useNavigationItems"
import { ExternalLink } from "components/external-link/ExternalLink"
import "./secondary-header.module.scss"
import { AnchorNumber } from "components/anchor-number/AnchorNumber"
import { useWindowDimensions } from "hooks/useWindowDimensions"
import { useSideNav } from "hooks/useSideNav"
import { ServiceDropdown } from "./ServiceDropdown"
import { useMainOfficeNumber } from "hooks/useMainOfficeNumber"

export const SecondaryHeader = () => {
  const { mainOfficeNumber } = useMainOfficeNumber({})
  const { trackingNumbers, customTrackingNumberCtaButtonText, isAlertEnabled } =
    useGeneralSettings()
  const windowAvailable = typeof window !== "undefined"
  const { height } = useWindowDimensions()
  const { isNavOpen } = useSideNav()
  const { secondaryHeaderNavigation } = useNavigationItems()

  const trackingNumberCTAText =
    customTrackingNumberCtaButtonText || "Call Today"

  const filteredDropdownList = secondaryHeaderNavigation.filter(
    navigationItems =>
      navigationItems.linkText === "Services Dropdown" &&
      navigationItems.childPages.length > 0
  )

  const filteredDropdown = filteredDropdownList[0]

  const secondaryHeaderNavigationWithoutDropdown =
    secondaryHeaderNavigation.filter(
      navItem => navItem.id !== filteredDropdown?.id
    )

  const hasDropdown =
    filteredDropdown &&
    Object.keys(filteredDropdown).length > 0 &&
    filteredDropdown.childPages.length > 1

  let scrollClass = ""
  if (height > 60 && !isAlertEnabled) {
    scrollClass = `fr-secondary-header--scroll-version ${
      isNavOpen ? "u-change-right-to-accomodate-scroll-bar-position" : ""
    }`
  } else if (height > 180 && isAlertEnabled) {
    scrollClass = `fr-secondary-header--scroll-version ${
      isNavOpen ? "u-change-right-to-accomodate-scroll-bar-position" : ""
    }`
  }
  return (
    <section className={`fr-secondary-header ${scrollClass}`}>
      <div
        className={`fr-container fr-container--large fr-secondary-header__inner`}
      >
        <div className="fr-secondary-header__inner--left">
          {secondaryHeaderNavigationWithoutDropdown &&
            secondaryHeaderNavigationWithoutDropdown.map(
              ({ linkText, externalLink, slug, svg_icon, id }) => {
                if (externalLink) {
                  return (
                    <ExternalLink
                      key={id}
                      href={externalLink}
                      className="fr-secondary-header__navigation-element"
                    >
                      <p className="fr-secondary-header__navigation-element__label">
                        {linkText}
                      </p>
                      {svg_icon && (
                        <span
                          className="fr-secondary-header__navigation-element__icon"
                          dangerouslySetInnerHTML={{ __html: svg_icon }}
                        />
                      )}
                    </ExternalLink>
                  )
                }

                return (
                  <>
                    {slug.includes("login") ? (
                      <a
                        href="/login"
                        key={id}
                        className="button--ghost-page-link fr-secondary-header__navigation-element"
                      >
                        <p className="fr-secondary-header__navigation-element__label">
                          {linkText}
                        </p>
                        {svg_icon && (
                          <span
                            className="fr-secondary-header__navigation-element__icon"
                            dangerouslySetInnerHTML={{ __html: svg_icon }}
                          />
                        )}
                      </a>
                    ) : (
                      <Button
                        key={id}
                        variant="ghost-page-link"
                        to={slug.startsWith("/") ? slug : `/${slug}`}
                        extraClassNames="fr-secondary-header__navigation-element"
                      >
                        <p className="fr-secondary-header__navigation-element__label">
                          {linkText}
                        </p>
                        {svg_icon && (
                          <span
                            className="fr-secondary-header__navigation-element__icon"
                            dangerouslySetInnerHTML={{ __html: svg_icon }}
                          />
                        )}
                      </Button>
                    )}
                  </>
                )
              }
            )}
        </div>
        {hasDropdown && (
          <div className="fr-secondary-header__inner--middle">
            <ServiceDropdown serviceAreas={filteredDropdown.childPages} />
          </div>
        )}
        <div className="fr-secondary-header__inner--right">
          {trackingNumbers.length >= 1 &&
            windowAvailable &&
            window.innerWidth > 550 && (
              <AnchorNumber
                trackingNumber={mainOfficeNumber}
                label={trackingNumberCTAText ?? trackingNumbers[0].label}
                svgIcon={trackingNumbers[0].svgIcon}
                baseClassName={"fr-secondary-header__navigation-element"}
              />
            )}
        </div>
      </div>
    </section>
  )
}
